module.exports = __webpack_public_path__ + "img/PL08346.b89bee3e.png";